// utils/constants.js
export const CALL_STATUS_MESSAGES = [
  { key: "ANSWER", value: "Call was answered successfully" },
  { key: "BUSY", value: "Line was busy" },
  { key: "NOANSWER", value: "No answer from recipient" },
  { key: "CANCEL", value: "Call was cancelled" },
  { key: "CONGESTION", value: "Network congestion" },
  { key: "CHANUNAVAIL", value: "Channel unavailable" },
  { key: "DONTCALL", value: "Recipient doesn't want to receive calls" },
  { key: "TORTURE", value: "Call was blocked due to harassment policy" },
  { key: "BLACKLIST", value: "Caller is blacklisted" },
  { key: "FAILED", value: "Call failed" },
];

export const TABLE_COLUMNS = {
  CALLER_ID: 'caller_id_number',
  DID_NUMBER: 'did_tfn',
  FORWARDED: 'forwarded_number',
  STATUS: 'hangup_reason',
  CALL_STATUS: 'call_result',
  BUYER_NAME: 'buyer_name',
  CAMPAIGN_NAME: 'campaign_name',
  DURATION: 'duration',
  RECORDING: 'recording_path',
  START_TIME: 'start_at',
  END_TIME: 'end_at',
};

export const DATE_FORMAT = {
  DISPLAY: 'DD/MM/YYYY HH:mm:ss',
  API: 'YYYY-MM-DD HH:mm',
  FILENAME: 'YYYYMMDD_HHmmss',
};